import { NodeIO } from "@gltf-transform/core";
import { ALL_EXTENSIONS } from "@gltf-transform/extensions";
import draco3d from "draco3dgltf";

export class GLTFTransformExporter {
  constructor() {
    this.io = null;
  }

  async init() {
    if (this.io != null) return;
    this.io = new NodeIO()
      .registerExtensions(ALL_EXTENSIONS)
      .registerDependencies({
        /*draco3d.decoder": await draco3d.createDecoderModule(), // Optional.*/
        "draco3d.encoder": await draco3d.createEncoderModule(), // Optional.
      });
  }

  async writeJSON(transformDocument) {
    const { json, resources } = await this.io.writeJSON(transformDocument);

    let i = 0;
    for (const uri in resources) {
      const resource = resources[uri];
      const ext = uri.split(".")[1];

      if (ext === "bin") {
        const contentType = "application/octet-stream";
        const dataUrl = await this.readDataAsBase64Url(resource, contentType);

        json.buffers[i].uri = dataUrl;
        json.buffers[i++].byteLength = resource.length;
      }
      if (ext === "jpg" || ext === "png" || ext === "jpg" || ext === "webp") {
        let imageSource = json.images.find((e) => e.uri === uri);

        const dataUrl = await this.readDataAsBase64Url(
          resource,
          imageSource.mimeType
        );
        imageSource.uri = dataUrl;
      }
    }
    return json;
  }

  async writeBinary(transformDocument) {
    return this.io.writeBinary(transformDocument);
  }

  async transform(gltfBinary) {
    try {
      const transformDocument = await this.io.readBinary(gltfBinary);
      return await transformDocument.transform((transform, options) => {
        this.seperateBuffer(transform);
        this.setDefaultImage(transform);
      });
    } catch (e) {
      console.error(e);
    }
  }

  seperateBuffer(transformDocument) {
    transformDocument
      .getRoot()
      .listBuffers()
      .forEach((buffer) => {
        buffer.dispose();
      });

    transformDocument
      .getRoot()
      .listTextures()
      .forEach((texture) => { });

    transformDocument
      .getRoot()
      .listMeshes()
      .forEach((mesh) => {
        const buffer = transformDocument.createBuffer();
        mesh.listPrimitives().forEach((prm) => {
          prm.listAttributes().forEach((acc) => {
            acc.setBuffer(buffer);
          });
        });
      });
  }

  extractImage(transformDocument) {
    const textures = transformDocument.getRoot().listTextures();
    textures.forEach((texture) => {
      const imageData = texture.getImage();
      this.downloadFile(imageData, "file.jpg", texture.getMimeType());
    });
  }

  setDefaultImage(transformDocument) {
    transformDocument
      .getRoot()
      .listTextures()
      .forEach((t) => {
        t.setMimeType("");
        t.setURI(
          "https://img-sugartech.mncdn.com/cdn.sugartech/mottobucket/Thumbnail/0_MasterMaviMorGriAna.jpg"
        );
      });
  }

  readDataAsBase64Url(buffer, contentType) {
    return (
      new Promise((resolve, reject) => {
        const blob = new Blob([buffer], { type: contentType });
        const reader = new FileReader();
        reader.onloadend = () => {
          //const base64data = reader.result.split(",")[1];
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      })
    );
  }

  downloadFile(
    data,
    name = "file",
    contentType = "application/octet-stream"
  ) {
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(
      new Blob([data], {
        type: contentType,
      })
    );
    link.download = name;
    link.click();
  }
}
